import { createActions } from 'redux-actions';

export default createActions({
  AUTH_SUCCESS: token => ({ token }),
  AUTH_LOGOUT: () => {},
});
